let count = 0;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());

export function startLoading() {
  count += 1;
  emit();
}

export function stopLoading() {
  count = Math.max(0, count - 1);
  emit();
}

export function subscribeLoading(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function getLoadingCount() {
  return count;
}
